import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-my-course-lesson-materials-route.tsx
var LazyMyCourseLessonMaterialsRoute = lazy(() => import("./my-course-lesson-materials-route-B-B3ISBH.js").then((n) => n.n).then((module) => ({ default: module.MyCourseLessonMaterialsRoute })));
function MyCourseLessonMaterialsRoute({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyMyCourseLessonMaterialsRoute, { ...props })
	});
}
var useMyCourseLessonMaterialsRoute = () => {
	return useMemo(() => ({ "my-course-lesson-materials-route": { component: MyCourseLessonMaterialsRoute } }), []);
};
//#endregion
export { useMyCourseLessonMaterialsRoute };
